export const WIDTH_MAX_CONTENT_WRAPPER = '1292px';

export const CARET_UP = 'up';
export const CARET_RIGHT = 'right';
export const CARET_DOWN = 'down';
export const CARET_LEFT = 'left';
